import { useDataProvider } from "src/system/useDataProvider.ts";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { useResourceQueries } from "src/framework/useResourceQueries.ts";
import { useContentLocale } from "src/auth/hooks/useContentLocale.tsx";

export const useCreateForm = <FormData = any,>(props: {
  resource: string;
  locale?: string;
  requestParams?: Record<string, any>;
  meta?: any;
  queryOptions?: Omit<
    UseQueryOptions<FormData, any, FormData>,
    "queryFn" | "queryKey"
  >;
}) => {
  const {
    resource,
    locale: localeProp,
    meta,
    queryOptions,
    requestParams,
  } = props;
  const dataProvider = useDataProvider();
  const queries = useResourceQueries();
  const defaultLang = useContentLocale();
  const locale = localeProp || defaultLang;
  return useQuery({
    queryKey: queries.createFormData({
      locale: locale,
      resource,
      meta,
      requestParams,
    }),
    queryFn: ({ signal }) => {
      return dataProvider.getCreateFormData({
        signal,
        resource,
        meta,
        locale: locale,
        requestParams,
      });
    },
    ...queryOptions,
  });
};
